<template>
  <view-wrapper
    name="Confirm Cancel/Pause Request"
    :loading="loading"
    :loadingText="loadingText"
  >
    <wrapper>
      <div class="flex flex-col" v-if="requestData && requestData.valid">
        <div class="flex items-center">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="flex-none w-8 h-8 mr-2"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
            />
          </svg>
          <h2>Warning</h2>
        </div>
        <span class="mt-1">
          You are about to cancel/pause your organization. This will result in
          all of your users to be logged out within 15 minutes time. Please save
          all of your work before clicking on the confirm button
        </span>
        <div class="mt-4 w-72">
          <grafokett-input
            v-model="code"
            placeholder="Confirmation Code"
            class="mt-4"
          />
        </div>
        <g-button
          class="mt-8 ml-auto primary"
          @click="confirmSubscriptionPause"
        >
          Confirm
        </g-button>
      </div>
      <div class="flex items-center" v-if="requestData && !requestData.valid">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          class="w-8 h-8 mr-2"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
          />
        </svg>
        <h2 class="font-light">{{ requestData.error }}</h2>
      </div>
    </wrapper>
    <modal type="warning" v-if="showError" @close="showError = false">
      <template slot="body">
        <h2>Error</h2>
        <p>Could not confirm the request</p>
      </template>
    </modal>
  </view-wrapper>
</template>

<script>
import ViewWrapper from "../components/ViewWrapper.vue";
import GButton from "../components/forms/Button.vue";
import GrafokettInput from "../components/forms/Input.vue";
import Modal from "../components/Modal.vue";

export default {
  components: { ViewWrapper, GButton, GrafokettInput, Modal },
  data() {
    return {
      loading: false,
      loadingText: "Validating token",
      requestData: null,
      code: "",
      showError: false,
    };
  },
  methods: {
    async getData() {
      this.loading = true;

      const { data } = await this.$store.$api.get(
        `/api/subscription/cancel/${this.$route.query.token}`
      );
      this.requestData = data;
      this.loading = false;
    },
    async confirmSubscriptionPause() {
      const oldLoadingText = this.loadingText;
      this.loadingText = "Confirming cancel/pause";
      this.loading = true;

      try {
        await this.$store.$api.post("/api/subscription/cancel/confirm", {
          token: this.$route.query.token,
          code: this.code,
        });
      } catch (error) {
        this.showError = true;
      }

      this.loading = false;
      this.loadingText = oldLoadingText;
    },
  },
  beforeMount() {
    this.getData();
  },
};
</script>
